<template>
	<div class="disclaimer">
		<div class="disclaimer-conatainer">
			<div class="disclaimer-btn" @click="toggleDisclaimer()">
				<p>{{ $t('disclaimer.title') }}</p>
				<img
					src="/assets/images/arrow.svg"
					:class="showDisclaimer ? '' : 'rotate'"
				/>
				<div class="security">
					<img
						src="../../../assets/images/ssl.svg"
						alt="secure encryption"
						class="security-img"
					/>
					<div class="security-content">
						<p class="secure-text">
							{{ $t('disclaimer.secure1') }}
							<span class="ssl-text">{{ $t('disclaimer.secure2') }}</span>
							{{ $t('disclaimer.secure3') }}
						</p>
					</div>
				</div>
			</div>
			<transition name="fade">
				<div class="flex flex-column gap-2">
					<div class="text-disclaimer">
						<p v-if="showDisclaimer">
							{{ $t('disclaimer.default.description') }}
						</p>
					</div>
					<div class="policy-container" v-if="showDisclaimer">
						<div
							v-for="policy in policies"
							:key="policy.name"
							class="policy-item"
						>
							<a :href="policy.url" target="_blank">{{ $t(policy.name) }}</a>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const policies = ref([
	{
		name: 'disclaimer.term',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf',
	},
	{
		name: 'disclaimer.privacy',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf',
	},
	{
		name: 'disclaimer.aml',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/08_AML+Policy.pdf',
	},
	{
		name: 'disclaimer.withdrawal',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/09_Withdrawal+Policy.pdf',
	},
	{
		name: 'disclaimer.refund',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/10_Refund+Policy.pdf',
	},
	{
		name: 'disclaimer.risk',
		url: 'https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf',
	},
])

const showDisclaimer = ref(true)

const toggleDisclaimer = () => {
	showDisclaimer.value = !showDisclaimer.value
}

const handleResize = () => {
	if (window.innerWidth <= 768) {
		showDisclaimer.value = false
	}
}

onMounted(() => {
	window.addEventListener('resize', handleResize)
	handleResize()
})

onBeforeUnmount(() => {
	window.removeEventListener('resize', handleResize)
})
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
